import React, { useState, useEffect } from 'react';
import { X, ArrowRight } from 'lucide-react';

const WHATSAPP_NUMBER = "34624476295";
const PHONE = "624 47 62 95";

const options = [
  {
    id: "solar",
    emoji: "☀️",
    label: "Instalar placas solares",
    sublabel: "Presupuesto gratuito en 24h",
    message: "Hola, me interesa instalar placas solares en mi vivienda/negocio. ¿Podéis hacerme un presupuesto gratuito?",
    color: "hover:border-solar-yellow hover:bg-yellow-50",
    iconBg: "bg-solar-yellow/15",
    iconText: "text-solar-yellow",
  },
  {
    id: "factura",
    emoji: "💡",
    label: "Reducir mi factura de luz",
    sublabel: "Ahorro medio del 30-70%",
    message: "Hola, quiero que analicéis mi factura de luz para ver cuánto puedo ahorrar. ¿Cómo funciona?",
    color: "hover:border-blue-300 hover:bg-blue-50",
    iconBg: "bg-blue-100",
    iconText: "text-blue-500",
  },
  {
    id: "tramite",
    emoji: "📋",
    label: "Gestionar un trámite",
    sublabel: "Alta, cambio titular, etc.",
    message: "Hola, necesito ayuda con una tramitación energética (alta de luz, cambio de titular, etc.). ¿Podéis ayudarme?",
    color: "hover:border-purple-300 hover:bg-purple-50",
    iconBg: "bg-purple-100",
    iconText: "text-purple-500",
  },
];

const WhatsAppFloating = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Mostrar tooltip después de 4 segundos
  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 4000);
    const hideTimer = setTimeout(() => setShowTooltip(false), 9000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  const handleOptionClick = (option) => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(option.message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setIsOpen(false);
  };

  return (
    <>
      {/* Panel de opciones */}
      {isOpen && (
        <div
          className="fixed bottom-24 right-4 md:right-6 z-50 w-80 bg-white rounded-3xl shadow-2xl border border-slate-100 overflow-hidden"
          style={{ animation: 'whatsapp-panel-in 0.3s cubic-bezier(0.16, 1, 0.3, 1)' }}
        >
          {/* Header */}
          <div className="bg-[#075E54] px-5 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div>
                <p className="text-white font-bold text-sm">AlgoMásQueLuz</p>
                <div className="flex items-center gap-1.5">
                  <div className="w-2 h-2 bg-[#25D366] rounded-full"></div>
                  <p className="text-white/70 text-xs">En línea ahora</p>
                </div>
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/70 hover:text-white transition-colors p-1"
              aria-label="Cerrar"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Mensaje de bienvenida */}
          <div className="px-5 py-4 bg-[#ECE5DD]">
            <div className="bg-white rounded-2xl rounded-tl-none px-4 py-3 shadow-sm max-w-[90%]">
              <p className="text-slate-700 text-sm font-manrope leading-relaxed">
                👋 ¡Hola! ¿En qué podemos ayudarte hoy?
              </p>
              <p className="text-xs text-slate-400 mt-1">AlgoMásQueLuz · ahora</p>
            </div>
          </div>

          {/* Opciones */}
          <div className="p-4 space-y-2">
            {options.map((option) => (
              <button
                key={option.id}
                onClick={() => handleOptionClick(option)}
                className={`w-full flex items-center gap-3 p-3.5 border-2 border-slate-100 rounded-2xl transition-all duration-200 group ${option.color}`}
                data-testid={`whatsapp-option-${option.id}`}
              >
                <div className={`w-10 h-10 ${option.iconBg} rounded-xl flex items-center justify-center flex-shrink-0 text-xl`}>
                  {option.emoji}
                </div>
                <div className="flex-1 text-left">
                  <p className="font-bold text-slate-900 text-sm">{option.label}</p>
                  <p className="text-xs text-slate-500">{option.sublabel}</p>
                </div>
                <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-slate-600 transition-colors" />
              </button>
            ))}
          </div>

          {/* Footer */}
          <div className="px-5 pb-4 pt-1 text-center border-t border-slate-100">
            <p className="text-xs text-slate-400 font-manrope">
              O llámanos al{' '}
              <a
                href={`tel:${PHONE.replace(/\s/g, '')}`}
                className="text-solar-yellow font-bold hover:underline"
              >
                {PHONE}
              </a>
            </p>
          </div>
        </div>
      )}

      {/* Tooltip */}
      {showTooltip && !isOpen && (
        <div
          className="fixed bottom-24 right-20 z-50 bg-slate-900 text-white text-sm py-2.5 px-4 rounded-2xl rounded-br-none shadow-xl font-manrope whitespace-nowrap"
          style={{ animation: 'fade-in 0.4s ease-out' }}
        >
          ¿Cuánto puedes ahorrar?
          <div className="absolute -right-2 bottom-0 w-0 h-0 border-l-8 border-l-slate-900 border-t-8 border-t-transparent"></div>
        </div>
      )}

      {/* Botón flotante */}
      <button
        onClick={() => {
          setIsOpen(!isOpen);
          setShowTooltip(false);
        }}
        className="fixed bottom-6 right-4 md:right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl transition-all duration-300 whatsapp-btn group"
        aria-label="Abrir chat de WhatsApp"
        data-testid="whatsapp-floating-btn"
        style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        {isOpen ? (
          <X className="w-7 h-7" />
        ) : (
          <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        )}
        {/* Indicador de notificación */}
        {!isOpen && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold leading-none">1</span>
          </span>
        )}
      </button>

      <style>{`
        @keyframes whatsapp-panel-in {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </>
  );
};

export default WhatsAppFloating;
